export default "__VITE_ASSET__CnC4faeu__"